import { AxiosResponse } from "axios"

import { DefaultSuccessResponse } from "./common/types"
import HttpService from "./http.service"

export type EmailKnowledgeStatus =
  | "pending"
  | "approved"
  | "rejected"
  | "archived"

export type EmailKnowledgeAttachment = {
  name: string
  mimeType?: string
  size?: number
  blobUrl?: string
  elasticSearchId?: string
}

export type EmailKnowledgeSubmission = {
  id: string
  messageId?: string
  fromAddress: string
  toAddress: string
  subject: string
  bodyText: string
  bodyHtml?: string | null
  brand?: string | null
  status: EmailKnowledgeStatus
  senderUserId?: string | null
  avatarId?: string | null
  reviewerUserId?: string | null
  reviewNote?: string | null
  reviewedAt?: string | null
  expertTopicId?: string | null
  expertSubTopicId?: string | null
  expertArticleId?: string | null
  expertInsightId?: string | null
  attachments: EmailKnowledgeAttachment[]
  sourceMetadata?: Record<string, unknown>
  createdAt: string
  updatedAt: string
}

export type EmailKnowledgeListResponse = DefaultSuccessResponse<{
  items: EmailKnowledgeSubmission[]
  total: number
  pageNum: number
  pageSize: number
}>

export type EmailKnowledgeUpdatePayload = {
  subject?: string
  bodyText?: string
  brand?: string
  reviewNote?: string
}

export type EmailKnowledgeApprovePayload = EmailKnowledgeUpdatePayload & {
  avatarId?: string
}

class EmailKnowledgeService extends HttpService {
  list = (params?: {
    status?: string
    query?: string
    pageNum?: number
    pageSize?: number
  }): Promise<AxiosResponse<EmailKnowledgeListResponse>> =>
    this.get("ts/email-knowledge", true, params)

  getById = (
    id: string
  ): Promise<AxiosResponse<DefaultSuccessResponse<EmailKnowledgeSubmission>>> =>
    this.get(`ts/email-knowledge/${id}`, true)

  update = (
    id: string,
    data: EmailKnowledgeUpdatePayload
  ): Promise<AxiosResponse<DefaultSuccessResponse<EmailKnowledgeSubmission>>> =>
    this.patch(`ts/email-knowledge/${id}`, data, true)

  approve = (
    id: string,
    data: EmailKnowledgeApprovePayload = {}
  ): Promise<AxiosResponse<DefaultSuccessResponse<EmailKnowledgeSubmission>>> =>
    this.post(`ts/email-knowledge/${id}/approve`, data, true)

  reject = (
    id: string,
    reviewNote?: string
  ): Promise<AxiosResponse<DefaultSuccessResponse<EmailKnowledgeSubmission>>> =>
    this.post(`ts/email-knowledge/${id}/reject`, { reviewNote }, true)

  archive = (
    id: string
  ): Promise<AxiosResponse<DefaultSuccessResponse<EmailKnowledgeSubmission>>> =>
    this.post(`ts/email-knowledge/${id}/archive`, {}, true)
}

export default new EmailKnowledgeService()
